import { defineMessages } from 'react-intl'

const scope = `procurify.modules.purchasing.features.set-po-bill-to-settings.presenters.po-bill-to-settings-presenter`

export default defineMessages({
  primaryCategorySuccessTitle: {
    id: `${scope}.primaryCategorySuccessTitle`,
    defaultMessage: 'Success',
  },
  primaryCategorySuccessMessage: {
    id: `${scope}.primaryCategorySuccessMessage`,
    defaultMessage:
      'Successfully updated the bill to {singularPrimaryOrgCategoryLabel}.',
  },
  contactSuccessTitle: {
    id: `${scope}.contactSuccessTitle`,
    defaultMessage: 'Success',
  },
  contactSuccessMessage: {
    id: `${scope}.contactSuccessMessage`,
    defaultMessage: 'Successfully updated the bill to contact.',
  },
  errorTitle: {
    id: `${scope}.errorTitle`,
    defaultMessage: 'Error',
  },
  errorMessage: {
    id: `${scope}.errorMessage`,
    defaultMessage: 'Something went wrong. Please try again later.',
  },
})
